import IconBase from './icon-base';

const IconChevron = ({ className, fill, height, hoverColor, width }) => (
  <IconBase className={className} viewBox="0 0 16 10" width={width} height={height} fill={fill} hoverColor={hoverColor}>
    <path d="M16 1.34646C16 1.46583 15.9641 1.56133 15.8924 1.63296L8.287 9.22524C8.21525 9.29687 8.11958 9.33268 8 9.33268C7.88042 9.33268 7.78475 9.29687 7.713 9.22524L0.107623 1.63296C0.0358744 1.56133 0 1.46583 0 1.34646C0 1.22708 0.0358744 1.13158 0.107623 1.05995L0.394619 0.773454C0.466368 0.701828 0.562033 0.666016 0.681614 0.666016C0.801196 0.666016 0.908819 0.701828 1.00448 0.773454L8 7.79274L14.9955 0.773454C15.0912 0.701828 15.1988 0.666016 15.3184 0.666016C15.438 0.666016 15.5336 0.701828 15.6054 0.773454L15.8924 1.05995C15.9641 1.13158 16 1.22708 16 1.34646Z" />
  </IconBase>
);

export default IconChevron;
